
import "./pWorkData/pWorkData.sass";
import "./pFlexitime/pFlexitime.sass";
import "./bFlexitimeTimeTable/bFlexitimeTimeTable.sass";
import "./bFlexitimeWorklogForm/bFlexitimeWorklogForm.sass";
import "./pDailyReport/pDailyReport.sass";
import "./pTeamLeaderView/pTeamLeaderView.sass";
import "./pPowerUserView/pPowerUserView.sass";
import "./pOvertimes/pOvertimes.sass";
import "./pOvertimesEmployee/pOvertimesEmployee.sass";
import "./pProfitabilityView/pProfitabilityView.sass";
import "./pProfitabilityViewManager/pProfitabilityViewManager.sass";
import "./pOvertimes/bAnnualSetOffs/bAnnualSetOffs.sass";
import "./pOvertimes/bAnnualSettle/bAnnualSettle.sass";
import "./pOvertimes/bAnnualSettle/bCreateSettlement/bCreateSettlement.sass";
import "./pOvertimes/bAnnualSettle/bEditSettlement/bEditSettlement.sass";

import { pDailyReportDirective } from './pDailyReport/pDailyReport.directive';
import { pWorkDataDirective } from './pWorkData/pWorkData.directive';
import { pFlexitimeDirective } from './pFlexitime/pFlexitime.directive';
import { bFlexitimeTimeTableDirective } from './bFlexitimeTimeTable/bFlexitimeTimeTable.directive';

import { lvlDraggableDirective, lvlDropTargetDirective } from './bFlexitimeTimeTable/DragAndDrop.directive';

import { bFlexitimeWorklogFormDirective } from './bFlexitimeWorklogForm/bFlexitimeWorklogForm.directive';
import { pTeamLeaderViewDirective } from './pTeamLeaderView/pTeamLeaderView.directive';
import { pPowerUserViewDirective } from './pPowerUserView/pPowerUserView.directive';
import { pOvertimesDirective } from './pOvertimes/pOvertimes.directive';
import { pOvertimesEmployeeDirective } from './pOvertimesEmployee/pOvertimesEmployee.directive';
import { bAnnualSetOffsDirective } from './pOvertimes/bAnnualSetOffs/bAnnualSetOffs.directive';
import { bAnnualSettleDirective } from './pOvertimes/bAnnualSettle/bAnnualSettle.directive';
import { bCreateSettlementDirective } from './pOvertimes/bAnnualSettle/bCreateSettlement/bCreateSettlement.directive';
import { bEditSettlementDirective } from './pOvertimes/bAnnualSettle/bEditSettlement/bEditSettlement.directive';
import { pProfitabilityViewDirective } from './pProfitabilityView/pProfitabilityView.directive';
import { pProfitabilityViewManagerDirective } from './pProfitabilityViewManager/pProfitabilityViewManager.directive';
import { StatsService } from './Stats.service';

export default angular.module('frontend.stats', ["frontend.api", "frontend.auth", "frontend.theme", "jkuri.datepicker", "nvd3", "angular-inview"])
  .directive('pDailyReport', pDailyReportDirective)
  .directive('pFlexitime', pFlexitimeDirective)
  .directive('bFlexitimeTimeTable', bFlexitimeTimeTableDirective)
  .directive('bFlexitimeWorklogForm', bFlexitimeWorklogFormDirective)
  .directive('pWorkData', pWorkDataDirective)
  .directive('pTeamLeaderView', pTeamLeaderViewDirective)
  .directive('pPowerUserView', pPowerUserViewDirective)
  .directive('pOvertimes', pOvertimesDirective)
  .directive('pOvertimesEmployee', pOvertimesEmployeeDirective)
  .directive('bAnnualSetOffs', bAnnualSetOffsDirective)
  .directive('bAnnualSettle', bAnnualSettleDirective)
  .directive('bCreateSettlement', bCreateSettlementDirective)
  .directive('bEditSettlement', bEditSettlementDirective)
  .directive('pProfitabilityView', pProfitabilityViewDirective)
  .directive('pProfitabilityViewManager', pProfitabilityViewManagerDirective)
  .directive("lvlDraggable", lvlDraggableDirective)
  .directive("lvlDropTarget", lvlDropTargetDirective)
  .service('Stats', StatsService);
